<template>
  <van-pull-refresh
    v-model="pullRefreshLoading"
    loading-text="刷新中..."
    success-text="刷新成功"
    :class="[_.waterfall, noCompleteTips && _.noCompleteTips]"
    :disabled="disabled"
    @refresh="handlePullRefresh"
  >
    <template v-if="empty">
      <slot name="empty">
        <dmbc-base-empty
          v-bind="{
            message: emptyText,
            noMargin: emptyNoMargin,
            ...emptyProps,
          }"
        />
      </slot>
    </template>
    <van-list
      v-else
      v-model="loading"
      :finished="finished"
      finished-text="已经到底啦~"
      @load="handleLoad()"
    >
      <slot :data="data" :record="record" :checkRecord="checkRecord" />
    </van-list>
    <slot name="extra" />
  </van-pull-refresh>
</template>

<script>
  import Vue from 'vue'
  import { wait } from 'vtils'

  export default Vue.extend({
    props: {
      load: {
        type: Function,
        required: true,
      },
      primaryKey: {
        type: String,
        default: undefined,
      },
      check: {
        type: Function,
        default: undefined,
      },
      emptyProps: {
        type: Object,
        default: () => ({}),
      },
      emptyText: {
        type: String,
        default: '暂无数据',
      },
      emptyNoMargin: {
        type: Boolean,
        default: false,
      },
      manual: {
        type: Boolean,
        default: false,
      },
      noCompleteTips: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      tabIsFixed: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      pageNumber: 0,
      data: [],
      latestSliceData: [],
      loading: true,
      pullRefreshLoading: false,
    }),

    computed: {
      empty() {
        return !this.loading && this.data.length === 0
      },
      finished() {
        return !this.loading && this.latestSliceData.length === 0
      },
    },

    created() {
      if (!this.manual) {
        this.handleLoad()
      }
    },

    activated() {
      this.checkRecord()
    },

    methods: {
      async handlePullRefresh() {
        this.pullRefreshLoading = true
        try {
          await Promise.all([
            this.handleLoad(1, false),
            // 下拉过程至少持续1秒，更丝滑一点
            wait(1000),
          ])
        } catch {}
        this.pullRefreshLoading = false
      },
      async handleLoad(
        pageNumber = this.pageNumber + 1,
        loading = true,
        source = null,
        clean = false,
      ) {
        if (this._loading) return
        this._loading = true
        this.loading = loading
        try {
          if (clean) {
            this.data = []
          }
          const res = await this.load({ pageNumber, source })
          const slice = Array.isArray(res) ? res : res.data || res.list || []
          this.pageNumber = pageNumber
          this.latestSliceData = slice
          this.data = pageNumber === 1 ? [...slice] : [...this.data, ...slice]
          this.$emit('change', this.data)
        } catch {}
        this.loading = false
        this._loading = false
      },
      async reload(source = null, clean = false) {
        if (this.tabIsFixed) {
          clean = true
        }
        await this.handleLoad(1, true, source, clean)
      },
      record(primaryValue) {
        this._primaryValue = primaryValue
      },
      async checkRecord(primaryValue = this._primaryValue, delay = 0) {
        if (typeof this.check === 'function') {
          const index = this.data.findIndex(
            item => item[this.primaryKey] === primaryValue,
          )
          if (index !== -1) {
            const item = this.data[index]
            if (delay) {
              await wait(delay)
            }
            const res = await this.check(item, index)
            if (res === false || res == null) {
              this.data.splice(index, 1)
            } else {
              this.data.splice(index, 1, res)
            }
          }
        }
      },
    },
  })
</script>

<style lang="scss" module="_">
  .waterfall {
    min-height: 100%;
    overflow: visible !important;

    &.noCompleteTips {
      :global {
        .van-list__finished-text {
          display: none;
        }
      }
    }

    :global {
      .van-pull-refresh__head {
        pointer-events: none;
      }
    }
  }
</style>
